/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Tlm_3Inputs */

const en_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`compliance`)
};

const ar_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الامتثال`)
};

const bn_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কমপ্লায়েন্স`)
};

const de_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konformität`)
};

const es_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformidad`)
};

const fr_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformité`)
};

const pt_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conformidade`)
};

const zh_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合规`)
};

const tr_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uyumluluk`)
};

const ru_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Соответствие`)
};

const pl_svc_ai_voice_agents_tlm_3 = /** @type {(inputs: Svc_Ai_Voice_Agents_Tlm_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zgodność`)
};

/**
* | output |
* | --- |
* | "compliance" |
*
* @param {Svc_Ai_Voice_Agents_Tlm_3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_tlm_3 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Tlm_3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Tlm_3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_tlm_3(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_tlm_3(inputs)
	return en_svc_ai_voice_agents_tlm_3(inputs)
});
export { svc_ai_voice_agents_tlm_3 as "svc_ai-voice-agents_tlm_3" }